module.exports = __webpack_public_path__ + "img/vip-green-line.43b76073.png";